import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import GameShowcase from './components/GameShowcase';
import Advantages from './components/Advantages';
import StatsSection from './components/StatsSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '开云棋牌如何注册账号？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '点击官网或APP上的"注册"按钮，输入手机号码获取验证码，设置登录密码即可完成注册。注册即送新人大礼包，包含免费欢乐豆和专属优惠券。',
      },
    },
    {
      '@type': 'Question',
      name: '平台支持哪些支付方式？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '开云棋牌支持微信支付、支付宝、银联卡、以及多种数字货币充值方式。充值秒到账，提现快速审核。',
      },
    },
    {
      '@type': 'Question',
      name: '如何保障游戏的公平性？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '采用国际认证的随机数生成算法（RNG），所有游戏结果由独立算法生成，平台无法操控。定期接受第三方权威机构审计。',
      },
    },
    {
      '@type': 'Question',
      name: '可以在哪些设备上玩？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '支持PC电脑端（Windows/Mac）、iOS手机端、Android手机端、平板电脑等多种设备。一个账号多端互通，数据实时同步。',
      },
    },
    {
      '@type': 'Question',
      name: '遇到问题如何联系客服？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '提供7×24小时在线客服服务。可通过APP内在线客服、官网联系页面、或拨打客服热线400-888-8888联系我们。',
      },
    },
    {
      '@type': 'Question',
      name: '新用户有哪些福利？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '新用户注册即送豪华大礼包：包含88888免费欢乐豆、首充双倍返利、每日签到奖励、邀请好友双方得奖励等。',
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    document.title = '开云棋牌 - 官方正版棋牌游戏平台 | 斗地主、麻将、德州扑克在线对战';
  }, []);

  return (
    <>
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <GameShowcase />
        <Advantages />
        <StatsSection />
        <Testimonials />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}